<template>
  <div class="replacephone">
    <Head :title="title"></Head>
    <div class="replacephone_content">
      <div
        style="
          font-size: 23px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-top: 100px;
          margin-left: 30px;
        "
      >
        请输入新手机号
      </div>
      <div
        style="
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-left: 30px;
          margin-top: 9px;
        "
      >
        更换后，下次可用新手机号码登录
      </div>
      <div style="margin-top: 30px; padding: 0px 20px 0px 14px">
        <van-form ref="phoneForm">
          <van-field
            v-model="phone"
            name="phone"
            placeholder="请输入手机号码"
            :rules="[
              { required: true },
              {
                pattern:
                  /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/,
                message: '手机号码格式不正确',
              },
            ]"
            style="
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #bbbbbb;
              border-bottom: 1px solid #eeeeee;
            "
          ></van-field>
        </van-form>
      </div>
    </div>
    <div class="exit">
      <van-button class="bot" @click="getCode">获取验证码</van-button>
    </div>
  </div>
</template>

<script>
import Head from "../components/headTabs.vue";
import { Toast } from "vant";
export default {
  name: "replacephone",
  components: {
    Head,
  },
  data() {
    return {
      information: "",
      title: "更换手机号",
      phone: "", // 手机号码
      disabled: true,
    };
  },
  watch: {
    phone: {
      handler(newV, OldV) {
        this.disabled = newV === this.information.account;
      },
    },
  },
  mounted() {
    this.information = JSON.parse(sessionStorage.getItem("userInfo"));
  },
  methods: {
    // 获取验证码
    getCode() {
      this.$refs.phoneForm.validate().then(async () => {
        if (this.disabled) {
          Toast("新手机号与原手机号一致，请重新输入");
        } else {
          const res = await this.$apis.loginServe.getCode({
            phone: this.phone,
            adapter: "change_bind",
          });
          if (res.resultCode == "200") {
            Toast("获取成功");
            this.$router.push({
              path: "/code",
              query: { phone: this.phone },
            });
          } else {
            Toast(res.resultDesc);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.replacephone {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #fff;
  .replacephone_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 100px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      margin: 0 auto;
    }
  }
  .replacephone_content {
    width: 94%;
    height: 100%;
    margin: 0 auto;
  }
  .exit {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 22px;
    .bot {
      width: 84%;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      background: #4a79f1;
    }
  }
}
</style>
